import React, { useState } from 'react';
import api from '../utils/api';
import { Phone, PhoneCall } from 'lucide-react';
import toast from 'react-hot-toast';

export default function CallButton({ leadId, mobile, name, size = 'normal', showLabel = true }) {
  const [calling, setCalling] = useState(false);
  const [called, setCalled] = useState(false);

  const initiateCall = async (e) => {
    e.stopPropagation();
    if (!mobile || calling) return;
    setCalling(true);
    try {
      const r = await api.post('/calls/click-to-call', { leadId, destinationNumber: mobile });
      if (r.data.success === false) {
        toast.error(r.data.error || 'Call failed');
      } else {
        toast.success(r.data.message || 'Call initiated! Your phone will ring first.', { duration: 4000 });
        setCalled(true);
        setTimeout(() => setCalled(false), 10000);
      }
    } catch (e) {
      toast.error(e.response?.data?.error || 'Call failed. Please check Tata Tele settings.');
    } finally {
      setCalling(false);
    }
  };

  const btnStyle = {
    background: called ? '#10b981' : calling ? '#6b7280' : '#0f1f3d',
    color: 'white', border: 'none',
    borderRadius: size === 'small' ? 6 : 8,
    padding: size === 'small' ? '4px 8px' : '8px 14px',
    fontSize: size === 'small' ? 11 : 13,
    fontWeight: 600, cursor: calling ? 'not-allowed' : 'pointer',
    display: 'inline-flex', alignItems: 'center', gap: size === 'small' ? 4 : 6,
    whiteSpace: 'nowrap'
  };

  return (
    <button style={btnStyle} onClick={initiateCall} disabled={calling}>
      {calling
        ? <span className="spinner" style={{ width: 12, height: 12, borderWidth: 1.5 }} />
        : called
        ? <PhoneCall size={size === 'small' ? 11 : 14} />
        : <Phone size={size === 'small' ? 11 : 14} />}
      {showLabel && (calling ? ' Calling...' : called ? ' Ringing...' : ' Call')}
    </button>
  );
}
